import { ModuleManager, SectionList } from "@module-system";

import WaitTransferModal from "./Components/WaitTransferModal.vue";
import CommonConditions from "@lib/commonConditions";
import locales from "./locales";
import TransferButton from "./Components/TransferButton.vue";
import TransferStartModal from "./Components/TransferStartModal.vue";
import configurationProvider from "@/Core/configurationProvider";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "Transfer",
  version: "1.0.0",
  register() {
    var transferEnabled = configurationProvider.getBoolRef("CALL_TRANSFER_ENABLED", true);
    if (!transferEnabled.value) {
      console.log("Transfer module disabled");
      return;
    }

    console.log("Transfer module initializing");

    ModuleManager.addViewModule({
      key: "wait-transfer-modal",
      section: SectionList.CallModal,
      ViewComponent: WaitTransferModal,
    });

    ModuleManager.addViewModule({
      key: "transfer-start-modal",
      section: SectionList.CallModal,
      ViewComponent: TransferStartModal,
    });

    const transferButtonConfig = window.CONFIG?.CALL_BUTTONS?.TRANSFER ?? {};
    transferButtonConfig.ENABLED = transferButtonConfig.ENABLED ?? true;
    transferButtonConfig.ORDER = transferButtonConfig.ORDER ?? 0;

    console.log("transferButtonConfig", transferButtonConfig);

    ModuleManager.addViewModule({
      Condition: (rtcId) => CommonConditions.isAgent(rtcId) && transferButtonConfig.ENABLED && transferEnabled.value,
      key: "transfer-button",
      section: SectionList.CallButtonsList,
      ViewComponent: TransferButton,
      order: transferButtonConfig.ORDER,
    });

    ModuleManager.addLocales(locales, "Transfer");
  },
};
export default module;
